import axios, {
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { TOKEN } from "constants/user";
import { HttpResponse } from "interfaces/common";
import { get } from "lodash";
import queryString from "query-string";

const request: AxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/api/v1`,
  headers: {
    "x-api-key": process.env.REACT_APP_API_KEY,
  },
  paramsSerializer: (params) => queryString.stringify(params),
});

request.interceptors.request.use((config: InternalAxiosRequestConfig<any>) => {
  const token = localStorage.getItem(TOKEN);

  if (!!token) {
    const parsedToken = JSON.parse(token);

    config.headers.Authorization = `Bearer ${parsedToken.accessToken}`;
  }

  return config;
});

request.interceptors.response.use(
  (response: AxiosResponse<HttpResponse<any>>) => {
    const pagination = get(response, "data._metadata.pagination");
    let data = response?.data?.data;

    if (pagination) {
      data = { data, pagination };
    }

    return data;
  },
  (error) => {
    if (get(error, "response.status") === 401) {
      localStorage.removeItem(TOKEN);
      window.location.href = "/auth/login";
    }

    return Promise.reject(get(error, "response.data") || error);
  }
);

export { request };
